<template>
    <Breadcrumbs main="Employee List" title="Black Listed Employee" />
    <div class="container-fluid">
        <div class="email-wrap">
            <div class="row">
                <black-listed-employee-main />
            </div>
        </div>
    </div>
</template>

<script lang="ts" setup>
import { defineAsyncComponent } from 'vue';
const BlackListedEmployeeMain = defineAsyncComponent(() => import("@/components/employee-list/black-listed-employee-list/black-listed-employee-list-table.vue"))
</script>